var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H513V341.993H0V-0.00683594Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7 118.593C246.6 109.093 230.7 103.993 214.4 104.093C173.6 104.093 140.6 134.893 140.6 172.993C140.6 211.093 173.7 241.893 214.4 241.893C231.5 241.893 247.3 236.493 259.7 227.393C229.7 265.993 174 272.993 135.4 242.893C96.7996 212.793 89.7996 157.193 119.9 118.593C150 79.9932 205.6 72.9932 244.2 103.093C250 107.593 255.2 112.893 259.7 118.593ZM299.6 184.393L281.5 206.293L282.7 177.893L256.3 167.493L283.6 159.893L285.4 131.593L301 155.293L328.5 148.193L311 170.193L326.3 194.093L299.6 184.393Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/TR.d151870157448dba10cd09e16db9a98c.svg";
export { ForwardRef as ReactComponent };